
import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [opacity, setOpacity] = useState({ title: 1, subtitle: 0 });
  const [animationStage, setAnimationStage] = useState(0);
  
  useEffect(() => {
    const timer1 = setTimeout(() => setAnimationStage(1), 1500);
    const timer2 = setTimeout(() => setAnimationStage(2), 2300);
    const timer3 = setTimeout(() => setAnimationStage(3), 3000);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
      
      const fadeOutPoint = 150;
      const titleOpacity = Math.max(0, 1 - position / fadeOutPoint);
      const subtitleOpacity = Math.min(1, position / fadeOutPoint);
      
      setOpacity({
        title: titleOpacity,
        subtitle: subtitleOpacity
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-white to-grow99x-lightBg">
      <div className="z-10 text-center px-4 relative">
        <div 
          className="relative h-24 mb-6 flex items-center justify-center"
          style={{ opacity: opacity.title }}
        >
          <div className="text-6xl md:text-8xl font-extrabold flex items-center justify-center">
            <span className="text-grow99x-text">
              Grow<span className="text-grow99x-orange">99X</span>
            </span>
          </div>
        </div>
        
        <p 
          className="text-2xl md:text-xl mb-8 max-w-xl mx-auto text-gray-600 transition-opacity duration-300"
          style={{ 
            opacity: opacity.title * (animationStage >= 2 ? 1 : 0),
            transform: animationStage >= 2 ? 'translateY(0)' : 'translateY(20px)',
            transition: 'transform 0.5s ease-out, opacity 0.5s ease'
          }}
        >
          Your local digital partner to grow your business 99 more times.
        </p>
        
        <button 
          onClick={scrollToContact}
          className="btn-primary"
          style={{ 
            opacity: Math.max(opacity.title, opacity.subtitle) * (animationStage >= 2 ? 1 : 0),
            transform: animationStage >= 2 ? 'translateY(0)' : 'translateY(20px)',
            transition: 'transform 0.5s ease-out, opacity 0.5s ease'
          }}
        >
          Let's Talk
        </button>
      </div>
      
      <div className="absolute top-1/4 right-10 w-24 h-24 rounded-full bg-grow99x-yellow opacity-20 blur-xl"></div>
      <div className="absolute bottom-1/4 left-10 w-32 h-32 rounded-full bg-grow99x-orange opacity-10 blur-xl"></div>
      <div className="absolute top-2/3 right-1/3 w-40 h-40 rounded-full bg-grow99x-green opacity-10 blur-xl"></div>
    </div>
  );
};

export default Hero;
